import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PageHead, Empty } from "@/components/tm/TmParts";

const TYPE_CLS = { overdue: "tm-bad", escalation: "tm-bad", blocked: "tm-warn", verify: "tm-review", verified: "tm-done", assignment: "tm-progress", mention: "tm-progress" };

export default function Notifications() {
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  const [filter, setFilter] = useState("all");
  const load = useCallback(() => api.get("/notifications").then((r) => setRows(r.data)).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);
  const markAll = async () => { await api.post("/notifications/read", { all: true }); load(); };
  const openOne = async (n) => { if (!n.read) await api.post("/notifications/read", { ids: [n.notif_id] }).catch(() => {}); if (n.link) nav(n.link); else load(); };
  if (!rows) return null;
  const list = rows.filter((n) => filter === "all" || (filter === "unread" ? !n.read : n.type === filter));
  const types = [...new Set(rows.map((n) => n.type))];
  return (
    <div className="space-y-5" data-testid="notifications-page">
      <PageHead title="Notification Centre" sub={`${rows.filter((n) => !n.read).length} unread`} right={<Button variant="outline" onClick={markAll} data-testid="ntf-mark-all">Mark all read</Button>} />
      <div className="flex flex-wrap gap-1.5">{["all", "unread", ...types].map((t) => <button key={t} onClick={() => setFilter(t)} className={`tm-chip h-8 px-3 capitalize ${filter === t ? "bg-primary text-white" : "tm-muted"}`} data-testid={`ntf-filter-${t}`}>{t}</button>)}</div>
      {!list.length ? <Empty text="No notifications." testid="ntf-empty" /> : (
        <div className="card-soft divide-y divide-border">
          {list.map((n) => (
            <div key={n.notif_id} onClick={() => openOne(n)} className={`flex items-start gap-3 p-3 cursor-pointer hover:bg-accent/50 ${n.read ? "opacity-70" : ""}`} data-testid={`ntf-${n.notif_id}`}>
              <span className={`tm-chip mt-0.5 ${TYPE_CLS[n.type] || "tm-muted"}`}>{n.type}</span>
              <div className="flex-1 min-w-0"><p className={`text-sm ${n.read ? "" : "font-semibold"}`}>{n.title}</p><p className="text-xs text-muted-foreground truncate">{n.message}</p></div>
              <span className="text-[11px] text-muted-foreground whitespace-nowrap">{String(n.created_at).slice(0, 16).replace("T", " ")}</span>
            </div>))}
        </div>)}
    </div>);
}
